import Vue from 'vue';
import Vuetify from 'vuetify/lib/framework';
import 'vuetify/dist/vuetify.min.css'
import colors from 'vuetify/lib/util/colors';


Vue.use(Vuetify);

const isDark = localStorage.getItem('darkMode') === 'true';

const opts = {
    theme: {
        dark: isDark,
        themes: {
            light: {
                primary: "#0072AC",
                secondary: colors.grey.darken1,
                accent: colors.shades.black,
                error: colors.red.accent3
            },
            dark: {
                primary: "#42A5F5",
                secondary: colors.grey.lighten1,
                accent: colors.blue.lighten3,
                error: colors.red.lighten2,
                background: "#121212",
                surface: "#1E1E1E",
            }
        }
    }
}

export default new Vuetify(opts);
